{
  "version": 1,
  "asset_id": "0f701486-c595-45a1-a2b4-7ab104a5e1cb",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/0f701486-c595-45a1-a2b4-7ab104a5e1cb/bypass-revision-resection-en-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/0f701486-c595-45a1-a2b4-7ab104a5e1cb/bypass-revision-resection-en-480.webp",
  "original_filename": "bypass-revision-resection-en-480.webp",
  "size": 40986,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:41:26Z"
}
